const HOME_PHONE = {
  FALLBACK_CURRENCY: "USD",
  SKELETON_COUNT: 2,
  ERRORS: {
    LOAD_PRODUCTS: "Unable to load home phone products.",
  },
} as const;

export default HOME_PHONE;
